import { useCallback, useEffect, useState } from "react";
import { getCampaignsByOrganizationAsync } from "../api/MessageApi";
import { MessageCampaign } from "../models/MessageModels";
import { Constants } from "../constants/constants";

interface UseCampaignsReturn {
  campaigns: MessageCampaign[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export const useCampaigns = (
  organizationId: string | undefined,
): UseCampaignsReturn => {
  const [campaigns, setCampaigns] = useState<MessageCampaign[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!organizationId) {
      setCampaigns([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem(Constants.ACCESS_TOKEN) || "";
      const res = await getCampaignsByOrganizationAsync(token, organizationId);
      if (res.success) {
        setCampaigns(res.result ?? []);
        setError(null);
      } else {
        setError(res.message || "Failed to load campaigns");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load campaigns");
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    load();
  }, [load]);

  const reload = useCallback(async () => {
    await load();
  }, [load]);

  return { campaigns, loading, error, reload };
};